<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ label }}</span>
		<div class="search-option-wrapper__normal" style="width: 300px">
			<el-radio v-model="radio" label="" @change="change">{{ getMessage_('MWCC000753') }}</el-radio>

			<el-radio v-model="radio" v-for="(item, index) in prcsRsltList" :key="index" :label="item.commCd" @change="change">{{
				item.commCdName
			}}</el-radio>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/ClamMst/store/helpers';
export default {
	props: ['label', 'paramKey'],
	data() {
		return {
			radio: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			//console.log('value값은', value);

			this.setSearchParam_({ key: 'prcRsltCd', value: value }).then(() => {
				//this.$emit('reload', 1, 10);
			});
		},
		processInfo() {
			this.radio = this.searchParams.prcRsltCd;
		}
	},
	created() {
		if (this.searchParams.prcRsltCd == null || this.searchParams.prcRsltCd == '') this.searchParams.prcRsltCd = '';
		this.radio = this.searchParams.prcRsltCd;
	}
};
</script>

<style></style>
